import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  brand: "Exserviceman Property Services",
  phone: "[Add Phone Number]",
  whatsapp: "910000000000",
  email: "[Add Email Address]",
  address: "[Add Office Address], Nagpur, Maharashtra",
  city: "Nagpur, Maharashtra, India",
};

const ConfigContext = createContext(DEFAULTS);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/config")
      .then((r) => setConfig({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);

export const waLink = (config, text) =>
  `https://wa.me/${config.whatsapp}?text=${encodeURIComponent(
    text || "Hello, I'm interested in plots around Nagpur. Please share details."
  )}`;
